import type { Router } from 'vue-router'

export function getCommonRouter(): Router | undefined {
  // @ts-ignore
  if (window.__SBB_CHAT_FS_ROUTER) return window.__SBB_CHAT_FS_ROUTER
}
